import { Passage, Room } from '..';
import { Direction, SpecialDirection } from '../../../parse';
import { EntitySpec } from '../../game';
import { VolcanoNearSmallLedge } from '../VolcanoNearSmallLedge';
import { VolcanoBottom } from '../VolcanoBottom';
import { Library } from '../Library';
import { Balloon, Hook1, VolcanoGnomeDoor, Zorkmid } from '../../items';

export class NarrowLedge extends Room {
    static spec(): EntitySpec<NarrowLedge> {
        return {
            ref: 'narrow-ledge',
            constructor: NarrowLedge,
            initial: {
                contents: [
                    Hook1.spec().ref,
                    Zorkmid.spec().ref,
                    VolcanoGnomeDoor.spec().ref,
                    // NarrowLedgeItem
                ],
                hasBeenVisited: false,
                hasBeenDescribed: false,
            },
            nouns: [],
            adjectives: [],
        };
    }

    ref() {
        return NarrowLedge.spec().ref;
    }

    name(): string {
        return 'Narrow Ledge';
    }

    description(): string {
        return (
            'You are on a narrow ledge overlooking the inside of an ' +
            'old dormant volcano. This ledge appears to be about in the ' +
            'middle between the floor below and the rim above. ' +
            'There is an exit here to the south.'
        );
    }

    isNaturallyLit(): boolean {
        return false;
    }

    passages(): Passage[] {
        return [
            new Passage({
                via: Direction.Down,
                message: "I wouldn't jump from here.",
            }),
            new Passage({
                via: SpecialDirection.Launch,
                to: VolcanoNearSmallLedge.spec().ref,
                allowedVehicles: [this.game.ent(Balloon)],
            }),
            new Passage({
                via: Direction.West,
                to: VolcanoBottom.spec().ref,
                // TODO this pattern of multiple conditions with multiple messages should be standardized with
                //      a list of conditions and messages if they fail to be met.
                condition: () => {
                    const door = this.game.ent(VolcanoGnomeDoor);
                    return !door.isHidden() && door.isOpen();
                },
                message: !this.game.ent(VolcanoGnomeDoor)?.isHidden()
                    ? 'The door is closed.'
                    : undefined,
            }),
            new Passage({
                via: Direction.South,
                to: Library.spec().ref,
            }),
        ];
    }
}
